import { IGetAllObraEstruturaOrganizacionalUseCase } from "../../../presentation/useCases/read/get_all_obra_estrutura_organizacional_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ObraEstruturaOrganizacional } from "../../models/obra_estrutura_organizacional";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObraEstruturaOrganizacionalUseCase
 */

export class GetAllObraEstruturaOrganizacionalUseCase
  extends BasePaginatedUseCase<ObraEstruturaOrganizacional>
  implements IGetAllObraEstruturaOrganizacionalUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraEstruturaOrganizacional(
    idObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllObraEstruturaOrganizacional(
        idObra,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
